<nav id="mu-menu-sidebar" aria-label="hidden" [ngClass]="{ 'mu-menu-sidebar-show': showMenu }" #musidebar>
  <div
    *ngFor="let menuItem of menuList"
    class="mu-menu-sidebar-item"
    [ngClass]="{
      'mu-menu-sidebar-item-disabled': !menuItem.active,
      'mu-menu-sidebar-item-active': [contextActive].includes(menuItem.contextPath),
      'mu-menu-sidebar-item-selected': [contextSelected].includes(menuItem.contextPath)
    }"
    [style]="'--color: ' + menuItem.fontColor"
    (click)="setSelectedContext(menuItem, menuItem.items?.length < 1 ? menuItem.routerLink : null)"
  >
    <div class="mu-menu-sidebar-item-content">
      <div class="mu-menu-sidebar-item-line" [style]="'--color: ' + menuItem.iconColor"></div>
      <i
        class="mu-icon mu-icon-arrow-up"
        [style]="'--color: ' + menuItem.iconColor"
        aria-hidden="true"
        *ngIf="menuItem.items?.length > 0"
      ></i>
      <i class="mu-menu-sidebar-icon" [ngClass]="menuItem.icon" aria-hidden="true" [style]="'--color: ' + menuItem.iconColor"></i>
      <span class="mu-menu-sidebar-text" [attr.translate]="menuItem.label.match(excludeTranslation['snd']) ? 'no' : 'yes'">{{
        menuItem.label
      }}</span>
    </div>

    <nav id="mu-menu-sidebar-subItem" aria-label="hidden">
      <div
        class="mu-menu-sidebar-item"
        *ngFor="let subMenuItem of menuItem.items"
        [routerLink]="subMenuItem.routerLink"
        routerLinkActive="mu-menu-sidebar-item-active"
        [routerLinkActiveOptions]="{ exact: true }"
        [style]="'--color: ' + subMenuItem.fontColor"
        (click)="hideSidebar()"
      >
        <div class="mu-menu-sidebar-item-content">
          <div class="mu-menu-sidebar-item-line" [style]="'--color: ' + menuItem.iconColor"></div>
          <i class="mu-menu-sidebar-icon" [ngClass]="subMenuItem.icon" aria-hidden="true" [style]="'--color: ' + subMenuItem.iconColor"></i>
          <span class="mu-menu-sidebar-text" [attr.translate]="subMenuItem.label.match(excludeTranslation['cedis']) ? 'no' : 'yes'">{{
            subMenuItem.label
          }}</span>
        </div>
      </div>
    </nav>
  </div>

  <div class="mu-menu-sidebar-item mu-menu-sidebar-item-active mu-menu-sidebar-item-help">
    <div class="mu-menu-sidebar-item-content">
      <i class="mu-menu-sidebar-icon mu-icon mu-icon-question-circle" aria-hidden="true"></i>
      <span class="mu-menu-sidebar-text"
        ><a [href]="helpLink" target="_blank">{{ 'common.help' | translate }}</a></span
      >
    </div>
  </div>
</nav>
